// Regras puras do fluxo de encaminhar mensagem (testáveis sem componente).

export const MAX_FORWARD_DESTINATIONS = 5;

// Resolve a inbox default para encaminhar a um CONTATO:
// 1. a inbox da mensagem de origem, se o contato for alcançável nela;
// 2. a única inbox disponível, se houver só uma;
// 3. null — o usuário precisa escolher num dropdown.
export const resolveDefaultInboxId = (contactInboxes, sourceInboxId) => {
  if (!Array.isArray(contactInboxes) || contactInboxes.length === 0)
    return null;
  const sourceMatch = contactInboxes.find(
    inbox => Number(inbox.id) === Number(sourceInboxId)
  );
  if (sourceMatch) return sourceMatch.id;
  if (contactInboxes.length === 1) return contactInboxes[0].id;
  return null;
};

// Monta o array de destinos do payload da API a partir dos itens selecionados.
export const buildDestinationsPayload = selectedItems =>
  selectedItems.map(item =>
    item.type === 'conversation'
      ? { conversation_display_id: item.id }
      : { contact_id: item.id, inbox_id: item.inboxId }
  );

// Um item de contato só está pronto quando tem inbox resolvida.
export const hasUnresolvedInbox = selectedItems =>
  selectedItems.some(item => item.type === 'contact' && !item.inboxId);
